var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$vuetify.breakpoint.smAndDown)?_c('div',[_c('vue-excel-xlsx',{ref:"EXPORT",attrs:{"data":_vm.data,"columns":_vm.columns,"file-name":_vm.fileName,"file-type":_vm.fileType,"sheet-name":_vm.sheetName}},[_c('v-btn',{attrs:{"rounded":"","color":"Secondary100","depressed":""}},[_vm._v("匯出")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }